import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { completeOidcLogin } from '../../slices/thunks';
import '../../App.css';
import { ClipLoader, MoonLoader } from 'react-spinners';

const SigninOidc = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(completeOidcLogin(navigate));
  }, [dispatch, navigate]);
  return (
    <div className='loading-container'>
      {/* 2. Gunakan komponen spinner dengan props yang diinginkan */}
      <MoonLoader
        color='#3498db' // Warna spinner
        loading={true} // Selalu true karena ini adalah halaman loading
        size={50} // Ukuran spinner dalam pixel
      />
      <p>Processing login...</p>
    </div>
  );
};

export default SigninOidc;
